'use strict';
define([
	'../../../base/PureComponent',
	'../../../utils/LayerUtil',
	'../../../g2',
	'../../PlotSchema'
], function(
	PureComponent,
	LayerUtil,
	g2,
	PlotSchema
) {
	var getDifferentData = PureComponent.extend({
		options: {
			title: '获取不同数据的类'
		},
		/*
		 * 初始化方法
		 * @param {Object}
		 * @param options.map 地图对象
		 * @param options.matchingLayer {Array} 必填,正则表达式匹配图层 例如：{ 'dataLayer': [/^visualize-/], 'plotLayer': [/^plot/] }
		 * */
		initialize: function(options) {
			PureComponent.prototype.initialize.call(this, options);
			//用来记录图层id
			this.layreIds = {
				"dataLayer": [],
				"plotLayer": []
			};
			this._matchingLayer = options.matchingLayer;
		},
		/*
		 * 销毁，对应initialize
		 * */
		destroy: function() {
			//清除变量
			PureComponent.prototype.destroy.call(this);
		},
		/**
		 * 初始化要同步的图层id
		 * @param {Array} matchingLayer 要匹配图层的标识数组
		 * */
		_initLayerId: function(matchingLayer) {
			var layers = this.map.getMap().getLayers();
			if(layers.length > 0) {
				for(var i = 0; i < layers.length; i++) {
					//匹配数据图层
					for(var j = 0; j < matchingLayer.dataLayer.length; j++) {
						if(matchingLayer.dataLayer[j].test(layers[i].id)) {
							this.layreIds.dataLayer.push(layers[i].id)
						}
					}
					//匹配标绘图层
					for(var j = 0; j < matchingLayer.plotLayer.length; j++) {
						if(matchingLayer.plotLayer[j].test(layers[i].id)) {
							this.layreIds.plotLayer.push(layers[i].id)
						}
					}
				}
			}
		}
	})
	/**
	 * 获取视野同步
	 * */
	getDifferentData.include({
		/**
		 * 获取视野同步的数据
		 * @return {Object} mapViewJson
		 * */
		getMapView: function() {
			var mapViewJson = {};
			mapViewJson.center = this.map._getMapCenter();
			mapViewJson.zoomLevel = this.map.getZoomLevel();
			return mapViewJson;
		}
	});
	/**
	 * 获取数据类型数据
	 * */
	getDifferentData.include({
		/**
		 * 获取数据同步数据
		 * @return {Object} syncDataJson 要同步的数据
		 * */
		getSyncData: function() {
			var syncDataJson = {};
			this._initLayerId(this._matchingLayer);
			var syncDataJson = this._getAllLayerData();
			return syncDataJson;

		},
		/**
		 * 要获取的图层的数据
		 * @return {Object} dataObj 获取的所有数据
		 * */
		_getAllLayerData: function() {
			var syncDataLayer = [];
			if(this.layreIds.dataLayer) {
				syncDataLayer = this.layreIds.dataLayer;
			}
			var dataObj = {};
			if(syncDataLayer && syncDataLayer.length > 0) {
				for(var i = 0; i < syncDataLayer.length; i++) {
					var layer = LayerUtil.getLayerById(this.map.getMap(), syncDataLayer[i]);
					if(layer) {
						var array = [];
						var elements = this._getLayerElements(layer);
						this._serializeElement(elements, array)
						dataObj[syncDataLayer[i]] = array;
					}
				}
			}
			return dataObj;
		}
	});
	/**
	 * 获取标绘类型数据
	 * */
	getDifferentData.include({
		/**
		 * 获取标绘数据
		 * @return {Object} plotDataJson 当前用户所有的标绘数据
		 * */
		getPlotData: function() {
			var plotDataJson = {};
			this._initLayerId(this._matchingLayer);
			var plotDataJson = this._getPoltData();
			return plotDataJson;
		},
		/**
		 * 获取指定图层的所有标绘
		 * @return {Object} plotDataJson 当前用户所有的标绘数据
		 * */
		_getPoltData: function() {
			var plotDataObj = {}
			var syncPlotLayer = [];
			if(this.layreIds.plotLayer) {
				syncPlotLayer = this.layreIds.plotLayer;
			}
			if(syncPlotLayer && syncPlotLayer.length > 0) {
				var schema = new PlotSchema({
					id: new Date().toString(),
					name: "标绘数据"
				});
				for(var i = 0; i < syncPlotLayer.length; i++) {
					var layerArr = this.map.getMap().layers;
					if(layerArr.length > 0) {
						for(var j = 0; j < layerArr.length; j++) {
							if(syncPlotLayer[i] == layerArr[j].id) {
								var elements = this._getLayerElements(layerArr[j]);
								this._serializeElement(elements, schema);
								plotDataObj[syncPlotLayer[i]] = schema;
							}
						}
					}
				}
			}
			return plotDataObj;
		}
	});
	/**
	 * 公共方法
	 * */
	getDifferentData.include({
		/**
		 * 获取一个图层的数据
		 * @param layer {g2.lys.ElementLayer} 图层
		 * @param arr {Array} 图层数据集合
		 * */
		_getLayerElements: function(layer) {
			var elements = [];
			if(layer instanceof g2.carto.GroupLayer) {
				var lys = layer.groupLayers;
				for(var j = 0, len = lys.length; j < len; j++) {
					var ly = lys[j];
					util._getLayerElements(ly, arr);
				}
			} else if(layer instanceof g2.carto.FeatureLayer) {
				//暂不处理
				// var elements=layer.features;
				// push2Arr(elements,arr);
			} else if(layer instanceof g2.carto.ElementLayer) {
				elements = layer.elements;
			} else if(layer instanceof g2.carto.ClusterLayer) {
				elements = layer.elements;
			}
			return elements;
		},
		/**
		 * 序列化对象
		 * @param {Array} eles 地图元素数组
		 * @param {Array} array 空数组
		 * */
		_serializeElement: function(eles, array) {
			for(var i = 0; i < eles.length; i++) {
				if(eles[i] instanceof g2.sfs.Element) {
					var obj = {};
					var geom = eles[i].geometry;
					obj.geom = geom.asWkt();
					obj.srid = geom.spatialReference;
					obj.symbol = eles[i].symbol;
					obj.$type = eles[i].$type;
					array.push(obj);
				} else if(eles[i] instanceof g2.sfs.PlotElement) {
					var ele = eles[i];				
					if(ele) {
						var cpy = ele.copy();
						cpy.unReset();
						for (let index = 0; index < cpy.elements.length; index++) {
							var element = cpy.elements[index];
							for (const key in element) {
								if (key=="parent") {
									element[key] = {};
								}
							}
							cpy.elements[index] = element;
							console.log(cpy.elements[index]);
						}
						cpy.id = ele.id;
						array.addElement(cpy);
					}
				}
			}
			return array;
		},
		_unRest(element){
			console.log(element);
			for (let index = 0; index < element.elements.length; index++) {
				element.elements[index].parent=null;
				if (element.elements[index].elements) {
					this._unRest(element.elements[index])
				}
			}
			return element;
		}
	})
	return getDifferentData;
})
